import { render, staticRenderFns } from "./WxUserinfoList.vue?vue&type=template&id=1057fe06&scoped=true&"
import script from "./WxUserinfoList.vue?vue&type=script&lang=js&"
export * from "./WxUserinfoList.vue?vue&type=script&lang=js&"
import style0 from "./WxUserinfoList.vue?vue&type=style&index=0&id=1057fe06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1057fe06",
  null
  
)

export default component.exports